import { useEffect } from 'react'

import { ActionIconEnum } from 'common/enums/ActionIcon'
import { DeepLinksEnum } from 'common/enums/DeepLink'
import BaseBridge from 'config/bridge/BaseBridge'
import { useNavBar } from 'hooks/useNavBar'
import { useHistory } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/mixedRoutes'
import useBoundState from 'store'
import { hasAnyTicket } from 'store/afterSales/handleTickets'
import { TabIdEnum } from 'common/enums/TabIdEnum'
import { useShouldDisplayRedemptionTab } from 'hooks/useShouldDisplayRedemptionTab'

import { TabPager } from '@interco/inter-ui/components/TabPager'

import { MyTicketsShimmer } from './myTickets/MyTickets/MyTickets.shimmer'
import { AnalyticsTabSelect, AnalyticsTicketHeader } from './AfterSales.tags'
import { MyTickets } from './myTickets/MyTickets/MyTickets'
import { Redemption } from './redemption/Redemption'
import * as S from './AfterSales.styles'

export const AfterSales = () => {
  const history = useHistory()
  const myTitle = useBoundState((state) => state.contentMyTitle)

  const selectedTab = useBoundState((state) => state.selectedTab)
  const setSelectedTab = useBoundState((state) => state.setSelectedTab)
  const isLoading = useBoundState((state) => state.isLoading)
  const tickets = useBoundState((state) => state.tickets)
  const queryParams = useBoundState((state) => state.queryParams)
  const getTickets = useBoundState((state) => state.getTickets)

  const isDeepLinkLandingPage = queryParams === DeepLinksEnum.LANDING_PAGE
  const hasRedemptionAvailable = (tickets.totalRedemptionAmount ?? 0) > 0
  const shouldDisplayRedemptionTab = useShouldDisplayRedemptionTab()

  useNavBar({
    actionIcons: {
      leftIcon: ActionIconEnum.BACK,
      rightIcon: ActionIconEnum.FAQ,
    },
    backListener: isDeepLinkLandingPage
      ? () => history.push(TypesRoutes.LANDING_PAGE_HOME)
      : () => BaseBridge.requestGoBack(),
    backButtonCallback: () => AnalyticsTicketHeader('42', 'back'),
    helpButtonCallback: () => AnalyticsTicketHeader('43', 'ajuda'),
    backTicName: 'go_back_btn_after_sales',
  })

  useEffect(() => {
    if (!hasAnyTicket(tickets)) {
      history.push(TypesRoutes.LANDING_PAGE_HOME)
      getTickets({ history, pathname: TypesRoutes.LANDING_PAGE_HOME })
    }
  }, [history, tickets, getTickets])

  const renderTabPager = () => (
    <TabPager
      currentTabId={selectedTab}
      tabItemStyle={{ width: '50%' }}
      tabPanelStyle={{ padding: '0' }}
      onTabSelect={(tabId) => {
        AnalyticsTabSelect(`${tabId}`)
        setSelectedTab(tabId)
      }}
      mainContainerStyle={{ width: '100%', padding: '0 24px' }}
      tabDefinitions={[
        {
          tabId: TabIdEnum.MY_TICKETS,
          label: <div style={{ display: 'flex', justifyContent: 'center' }}>{myTitle.value2}</div>,
          content: <MyTickets />,
        },
        {
          tabId: TabIdEnum.REDEMPTION,
          label: (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              Resgate {hasRedemptionAvailable ? <S.DotAlert data-testid="dot-alert" /> : ''}
            </div>
          ),
          content: <Redemption />,
        },
      ]}
    />
  )

  return isLoading ? (
    <MyTicketsShimmer />
  ) : (
    <>
      {shouldDisplayRedemptionTab ? (
        renderTabPager()
      ) : (
        <S.MyTicketsWrapper>
          <MyTickets />
        </S.MyTicketsWrapper>
      )}
    </>
  )
}
